import React from 'react';

interface ModeBannerProps {
  text: string;
  bgColor: string;
  textColor: string;
}

const ModeBanner: React.FC<ModeBannerProps> = ({ text, bgColor, textColor }) => {
  return (
    <span
      className={`inline-block p-2 text-sm ${textColor} ${bgColor} fixed top-0 left-1/2 rounded-b-xl`}>
      {text}
    </span>
  );
};

export default ModeBanner;
